import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { DistrictEntity } from "../district/district.entity";
import { ParliamentEntity } from "./parliament.entity";

@Entity('Assembly')
export class AssemblyEntity {  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  id:number;
 
  @Column("varchar",{
    nullable: false,
    length:100,
    name:"Assemblyname"
  })
  Assemblyname:string;

  @Column("int",{
    nullable:true,
    name:"ParliamentID"
  })
  ParliamentID:number;

  @ManyToOne(()=>ParliamentEntity, (parliament:ParliamentEntity)=>parliament.asemb)
  @JoinColumn({name:"ParliamentID"})
  parliament:ParliamentEntity;
  
}